import React, { useState, useEffect, useCallback } from 'react';
import {
  DataGridPro,
  GridToolbarContainer,
  GridToolbarExport,
} from '@mui/x-data-grid-pro';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { Auth } from 'aws-amplify';
import { ContentTitle, RightButton } from '../ui/styled';
import BackIcon from '../common/Back/BackIcon';
import PageHeading from '../common/Heading/PageHeading';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  AUTHORIZATION_LIST_URL,
  COMPLETION_REPORT_URL,
  COMPLETION_REPORT_AGE_URL,
  COMPLETION_REPORT_ETHNICITY_URL,
  COMPLETION_REPORT_FUNDING_URL,
  paginationSize,
  EPISODE_2284_REFERENCE_DATA_URL,
  EPISODE_AUTHORIZATION_REFERENCE_DATA_URL,
  EPISODE_CMP_REFERENCE_DATA_URL,
  AUTHORIZATION_LIST_PAGESIZE_URL,
} from '../../constants';
import { commonQueryParams } from '../../services/QueryParams/QueryParams';
import CommonSearch from '../common/Search/CommonSearch';
import { getAuthorizationList, getCompletionList } from './services/authorizationsApi';
import { getAuthReferenceData } from '../../redux/episode/authTab/authReferenceSlice';
import { get2284ReferenceData } from '../../redux/episode/2284Tab/2284Reference/2284ReferenceSlice';
import { getCmpReferenceData } from '../../redux/episode/cmpTab/cmpReference/cmpReferenceSlice';
import { singleEpisode } from '../../redux/episode/episodeSlice';
import { participant } from '../../redux/participant/participantSlice';
import { LeftGrid } from '../Episode/Episode.Styled';
import AuthorizationPdfDialog from './AuthorizationPdfDialog';
import AuthorizationReportsCalomsactPdfDialog from './AuthorizationReportsCalomsactPdfDialog';
import { getStopApi } from '../../services/StopApi/StopApi';
import CompletionRatio from '../common/Reports/CompletionRatio';



const AuthorizationList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [searchAuthorizationList, setSearchAuthorizationList] = useState('');
  const [visibleAuthIds, setVisibleAuthIds] = useState('');
  //console.log('visibleAuthIds', visibleAuthIds);
  const [openCompletionRatioSettings, setOpenCompletionRatioSettings] = useState(false);
  const [openCompletionRatioDialog, setOpenCompletionRatioDialog] = useState(false);
  const [completionRatioData, setCompletionRatioData] = useState({});
  const [openAuthorizationPdfDialog, setOpenAuthorizationPdfDialog] =
    useState(false);
  const [
    openAuthorizationReportsCalomsactPdfDialog,
    setOpenAuthorizationReportsCalomsactPdfDialog,
  ] = useState(false);
  const [authorizationList, setAuthorizationList] = useState({
    isLoading: false,
    data: [],
    total: 0,
    page: 1,
    pageSize: 10,
    sortModel: '',
    filterModel: {},
  });

  useEffect(() => {
    if (user?.signInUserSession.accessToken.jwtToken) {
      fetchData();
      //fetchAuthorizationIds();
    }
    getUser().then((userData) => setUser(userData));
  }, [
    user?.signInUserSession.accessToken.jwtToken,
    authorizationList.pageSize,
    authorizationList.page,
    authorizationList.sortModel,
    authorizationList.filterModel,
    searchAuthorizationList,
  ]);

  const getUser = () => {
    return Auth.currentAuthenticatedUser()
      .then((userData) => userData)
      .catch(() => console.log('Not signed in'));
  };

  const QuickSearchToolbar = () => {
    return (
      <Box pt={1} sx={{ flexGrow: 1, backgroundColor: '#747070' }}>
        <Grid container spacing={1}>
          <Grid item xs={11}>
            <CommonSearch
              searchText={searchAuthorizationList}
              setSearchText={setSearchAuthorizationList}
            />
          </Grid>
          <Grid item xs={1}>
            <GridToolbarContainer>
              <GridToolbarExport />
            </GridToolbarContainer>
          </Grid>
        </Grid>
      </Box>
    );
  };

  const fetchData = async () => {
    setAuthorizationList((old) => ({ ...old, isLoading: true }));
    const commonParams = commonQueryParams(
      AUTHORIZATION_LIST_URL,
      searchAuthorizationList,
      authorizationList
    );
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    const authorizations = await getAuthorizationList({
      commonParams,
      authorization,
    });
    setAuthorizationList((old) => ({
      ...old,
      ...authorizations,
    }));

    fetchAuthorizationIds();

    //let IDs = '';
    //authorizations?.data.forEach(function (item) {
    //  IDs += item.authId + ',';
    //});
    //setVisibleAuthIds(IDs.slice(0, -1));
  };

  const fetchAuthorizationIds = async () => {
    const commonParams = commonQueryParams(
      AUTHORIZATION_LIST_URL,
      searchAuthorizationList,
      {...authorizationList, pageSize:'500'}
    );
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    getStopApi({ commonParams, authorization }).then((response) => {
      const json = response.data;
      let IDs = '';
      json?.forEach(function (item) {
        IDs += item.authId + ',';
      });
      setVisibleAuthIds(IDs.slice(0, -1));
    }).catch((e) => console.log(e));
  };

  const handleSortModelChange = useCallback((sortModel) => {
    // Here you save the data you need from the sort model
    setAuthorizationList((old) => ({ ...old, sortModel: [...sortModel] }));
  }, []);

  const handleFilterChange = useCallback((filterModel) => {
    // Here you save the data you need from the filter model
    //console.log(filterModel);
    setAuthorizationList((old) => ({
      ...old,
      filterModel: { ...filterModel },
    }));
  }, []);

  const episodeRowClick = (rowData) => {
    //console.log('### CLICK FROM AUTH LIST');
    //console.log(rowData);

    const episode = [
      {
        episodeId: rowData.episode.epdID,
        referralSource: rowData.referralSource,
        cdc: rowData.episode.CDC,
      },
    ];
    const authReferenceUrl = `${EPISODE_AUTHORIZATION_REFERENCE_DATA_URL}/${rowData.episode.epdID}/referencedata/${rowData.episode.paroleCounty?.cnyId}`;
    const reference2284Url = `${EPISODE_2284_REFERENCE_DATA_URL}/${rowData.episode.epdID}`;
    const cmpReferenceUrl = `${EPISODE_CMP_REFERENCE_DATA_URL}/${rowData.episode.epdID}`;
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    dispatch(getAuthReferenceData({ authReferenceUrl, authorization }));
    dispatch(get2284ReferenceData({ reference2284Url, authorization }));
    dispatch(getCmpReferenceData({ cmpReferenceUrl, authorization }));
    dispatch(singleEpisode(episode));

    const participantDetail = [
      {
        key: rowData.paticipantKey,
        id: rowData.prtID,
        //lastName: rowData.participant.lastName,
        //firstName: rowData.participant.firstName,
        //middleName: rowData.participant.middleName,
        //ssn: rowData.participant.SSN,
        //suffix: rowData.participant.suffix,
        gender: rowData.episode.partcipant.gnd,
        //ethnicityOrRace: rowData.participant.ethnicityOrRace,
        //veteran: rowData.participant.veteran,
        //deployedCombatDuty: rowData.participant.deployedCombatDuty,
        //diagnosedPostTraumaticStressDisorder:
        //  rowData.participant.diagnosedPostTraumaticStressDisorder,
        //arsonist: rowData.arsonist,
        //dateOfBirth: rowData.participant.dateOfBirth,
        registration290: rowData.registratnt290,
        //inactive: rowData.participant.inactive,
        cdcNum: rowData.CDC
      },
    ];
    //console.log('### PARTICIPANT DETAIL');
    //console.log(participantDetail)
    dispatch(participant(participantDetail));

    navigate(`/episode/details/${rowData.episode.epdID}`);
  };

  const columnsData = [
    //{ field: 'flag', type: 'boolean', headerName: 'Flag', filterable: false },
    {
      field: 'epdID',
      headerName: 'Episode Id',
      filterable: false,
      renderCell: (params) => {
        return (
          <Button
            variant="contained"
            size="small"
            onClick={() => episodeRowClick(params.row)}
          >
            {params.value}
          </Button>
        );
      },
    },
    {
      field: 'authId',
      headerName: 'Auth Id',
      filterable: false,
      renderCell: (params) => {
        return (
          <Button
            variant="contained"
            size="small"
            onClick={() => episodeRowClick(params.row)}
          >
            {params.value}
          </Button>
        );
      },
    },
    {
      field: 'start',
      headerName: 'Start',
      type: 'date',
    },
    {
      field: 'end',
      headerName: 'End',
      type: 'date',
    },
    {
      field: 'admit',
      headerName: 'Admit',
      type: 'date',
    },
    {
      field: 'discharge',
      headerName: 'Discharge',
      type: 'date',
    },
    {
      field: 'episode',
      headerName: 'Referral Source',
      minWidth: 150,
      valueGetter: (params) => {
        return params?.value?.referralSource?.value;
      },
    },
    {
      field: 'authType',
      headerName: 'Auth Type',
      minWidth: 150,
    },
    {
      field: 'authDischargeType',
      type: 'date',
      headerName: 'Auth Discharge Type',
      filterable: false,
    },
    //{ field: 'reg', headerName: 'Reg', filterable: false },
    {
      field: 'paticipantKey',
      headerName: 'Participant Key',
      filterable: false,
    },
    { field: 'gnd', headerName: 'Gnd' },
    { field: 'CCCMS', headerName: 'CCCMS', type: 'boolean', filterable: false },
    { field: 'registratnt290', headerName: '290 Registrant', type: 'boolean' },
    { field: 'MOD', headerName: 'Mod' },
    { field: 'CBPID', headerName: 'CBP ID', filterable: false },
    {
      field: 'CBPName',
      headerName: 'CBP Name',
      minWidth: 300,
      filterable: false,
    },
    { field: 'prtID', headerName: 'Prt ID', filterable: false },
    //{ field: 'maxUnits', headerName: 'Max Units', filterable: false },
    //{ field: 'maxUnitsPerWeek', headerName: 'Max Units Per Week', filterable: false },
    //{ field: 'sb1453Eligible', headerName: 'SB1453 Eligible', type: 'boolean', filterable: false },
    {
      field: 'fundingSap',
      headerName: 'Funding Sap',
      minWidth: 150,
      filterable: false,
    },
    // { field: 'paroleCounty', headerName: 'Parole County' },
    // { field: 'excludeNonStop', headerName: 'Exclude Non Stop' },
    // {
    //   field: 'calOmsAdmitReceived',
    //   headerName: 'CalOms Admit Received',
    // },
    // {
    //   field: 'calOmsDischargeReceived',
    //   headerName: 'CalOms Discharge Received',
    // },
    // {
    //   field: 'calOmsAdmorDchReceived',
    //   headerName: 'CalOms Admor Dch Received',
    // },
  ];

  const handlePopSheet = () => {
    setOpenAuthorizationPdfDialog(true);
  };

  const handleCalomsactReports = () => {
    setOpenAuthorizationReportsCalomsactPdfDialog(true);
  };

  const handleCompletion = () => {
    if (!commonQueryParams(COMPLETION_REPORT_URL,searchAuthorizationList,authorizationList).includes('filter='))
      alert('Please filter Authorization list before running completion ratio');
    else
      setOpenCompletionRatioSettings(true);
  };

  const handleCompletionRatio = (variant) => {
    //alert(variant.id);
    var url;
    var nav;
    if (variant.id==1) {
      url = COMPLETION_REPORT_URL;
      nav = '/report/completion';
    }
    else if(variant.id==2) {
      url = COMPLETION_REPORT_AGE_URL;
      nav = '/report/completion/age';
    }
    else if(variant.id==3) {
      url = COMPLETION_REPORT_ETHNICITY_URL;
      nav = '/report/completion/ethnicity';
    }
    else {
      url = COMPLETION_REPORT_FUNDING_URL;
      nav = '/report/completion/funding';
    }
    navigate(nav, 
      {
        state:
        {
          commonParams: commonQueryParams(url, searchAuthorizationList, authorizationList),
          filterModel: authorizationList.filterModel
        }
      }
    );
  }


  return (
    <>
      <ContentTitle container>
        <Grid item xs={4}>
          <Box style={{ display: 'flex', alignItems: 'center' }}>
            <BackIcon />
            <PageHeading title="Authorizations" />
          </Box>
        </Grid>
        <Grid item xs={4}>
          <Box style={{ alignItems: 'center' }}>
            <Typography variant="h4" align="center">
              Authorizations
            </Typography>
          </Box>
        </Grid>
        <LeftGrid item xs={4}>
          <Button
            variant="contained"
            style={{ justifyContent: 'flex-end' }}
            onClick={handleCompletion}
          >
            Completion Ratio
          </Button>
          <RightButton
            variant="contained"
            style={{ justifyContent: 'flex-end' }}
            onClick={handlePopSheet}
          >
            Pop Sheet
          </RightButton>
          <RightButton
            variant="contained"
            onClick={handleCalomsactReports}
          >
            CalOms Activity
          </RightButton>
        </LeftGrid>
      </ContentTitle>
      <div style={{ height: 670, width: '100%' }}>
        <div style={{ display: 'flex', height: '100%' }}>
          <div style={{ flexGrow: 1 }}>
            <DataGridPro
              filterMode="server"
              onFilterModelChange={handleFilterChange}
              //autoHeight
              //getRowHeight={() => 'auto'}
              columns={columnsData}
              rows={authorizationList.data}
              pageSize={authorizationList.pageSize}
              page={authorizationList.page - 1}
              rowCount={authorizationList.total}
              paginationMode="server"
              sortingMode="server"
              onPageSizeChange={(newPageSize) =>
                setAuthorizationList((old) => ({ ...old, pageSize: newPageSize }))
              }
              onPageChange={(newPage) => {
                setAuthorizationList((old) => ({ ...old, page: newPage + 1 }));
              }}
              rowsPerPageOptions={paginationSize}
              pagination
              components={{ Toolbar: QuickSearchToolbar }}
              experimentalFeatures={{ newEditingApi: true }}
              onSortModelChange={handleSortModelChange}
              getRowClassName={(params) =>
                params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
              }
              loading={authorizationList.isLoading}
            />
          </div>
        </div>
      </div>      
      <CompletionRatio
        cancelPopUp={openCompletionRatioSettings}
        setCancelPopUp={setOpenCompletionRatioSettings}
        submit={handleCompletionRatio}
      />
      <AuthorizationPdfDialog
        openAuthorizationPdfDialog={openAuthorizationPdfDialog}
        setOpenAuthorizationPdfDialog={setOpenAuthorizationPdfDialog}
      />
      <AuthorizationReportsCalomsactPdfDialog
        openAuthorizationReportsCalomsactPdfDialog={
          openAuthorizationReportsCalomsactPdfDialog
        }
        setOpenAuthorizationReportsCalomsactPdfDialog={
          setOpenAuthorizationReportsCalomsactPdfDialog
        }
        visibleAuthIds={visibleAuthIds}
      />
      {/*<CompletionRatioDialog
        open={openCompletionRatioDialog}
        setOpen={setOpenCompletionRatioDialog}
        data={completionRatioData}
      />*/}
    </>
  );
};
export default AuthorizationList;
